import { client } from '@/lib/apiClient'

/**
 * 접속 IP 검증 API
 * - JWT 불필요 (로그인 전 호출)
 * - 백엔드에서 요청 IP를 자동 추출하여 허용 여부 판단
 * @returns {Promise<boolean>} 허용 여부
 */
export const verifyClientIp = async () => {
  const debug = import.meta.env.VITE_SHOW_IP_DEBUG === 'true'

  try {
    // [디버깅] web-admin 확인 IP (클라이언트 공인 IP)
    if (debug) {
      fetch('https://api.ipify.org?format=json')
        .then(r => r.json())
        .then(d => console.log('[IP 검증] web-admin 확인 IP:', d.ip))
        .catch(() => console.log('[IP 검증] web-admin 확인 IP: 조회 실패'))
    }

    // res-mngr 확인 IP (백엔드 감지 IP)
    const res = await client.post('ip-manage/adm-ip-verify').json()
    const mngrIp = res?.data?.detectedIp
    const allowed = res?.data?.allowed

    if (debug) {
      if (res?.data) {
        console.log('[IP 검증] res-mngr 확인 IP:', mngrIp, '| 허용 여부:', allowed)
      }

      // 분기별 예상 원인 진단
      console.group('[IP 검증] 분기별 예상 원인')
      if (allowed) {
        console.log('✅ 정상 — IP 허용됨')
        console.log('  └ res-mngr 감지 IP가 yml 항상허용 목록 또는 DB 허용 규칙에 매칭됨')
      } else if (mngrIp && (mngrIp.startsWith('10.') || mngrIp.startsWith('172.') || mngrIp.startsWith('192.168.'))) {
        console.log('❌ 차단 — res-mngr 확인 IP가 내부 대역 (K8s/프록시 문제 의심)')
        console.log('  └ 예상 원인: 인그레스(Ingress)가 X-Forwarded-For 헤더를 전달하지 않아 파드/노드 내부 IP가 감지됨')
        console.log('  └ 조치: 인그레스 설정에서 X-Forwarded-For / proxy-real-ip-cidr 확인 필요')
      } else if (mngrIp && mngrIp !== '115.93.81.76') {
        console.log('❌ 차단 — res-mngr 확인 IP가 예상 IP(115.93.81.76)와 다름')
        console.log('  └ 예상 원인: VPN, 프록시, 또는 NAT 경유로 출구 IP가 변경됨')
        console.log('  └ 조치: 감지된 IP를 yml always-allowed 또는 DB 허용 규칙에 추가')
      } else if (mngrIp === '115.93.81.76' && !allowed) {
        console.log('❌ 차단 — IP는 일치하나 DB 거부 규칙에 우선 매칭됨')
        console.log('  └ 예상 원인: DB에 해당 IP를 포함하는 거부(N) 규칙이 존재')
        console.log('  └ 조치: 관리자 > 환경설정 > 접속IP관리에서 거부 규칙 확인')
      } else {
        console.log('❌ 차단 — 원인 미상')
        console.log('  └ res-mngr 확인 IP:', mngrIp || '조회 실패')
        console.log('  └ 조치: 서버 로그 확인 필요')
      }
      console.groupEnd()
    }

    return res?.result === true && allowed === true
  } catch {
    console.log('[IP 검증] API 호출 실패 — 네트워크 오류 또는 백엔드 미응답')
    return false
  }
}
